import * as React from 'react';
import Drawer from '@mui/material/Drawer';
import { useTheme } from '@mui/material/styles';

import Toolbar from '@mui/material/Toolbar';

import IconButton from '@mui/material/IconButton';
import Divider from '@mui/material/Divider';

import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

type SideNavProps = {
    open: boolean;
    width: number;
    topOffset: number;
    children: React.ReactNode;
    onClose: () => void;
};

export const SideNav = ({
    width,
    open,
    topOffset,
    onClose,
    children,
}: SideNavProps) => {
    const theme = useTheme();

    return (
        <Drawer
            sx={{
                width: width,
                flexShrink: 0,
                '& .MuiDrawer-paper': {
                    width: width,
                    boxSizing: 'border-box',
                    top: topOffset,
                    height: `calc(100% - ${topOffset}px)`,
                },
            }}
            variant="persistent"
            anchor="left"
            open={open}
        >
            <Toolbar sx={{ justifyContent: 'flex-end', px: 1 }}>
                <IconButton onClick={onClose}>
                    {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                </IconButton>
            </Toolbar>
            <Divider />
            {children}
            <Divider />
        </Drawer>
    );
};